import { useQuery } from '@tanstack/react-query';
import { useLocale } from 'next-intl';
import {
  onboardingService,
  type OnboardingSlide,
} from '../api/onboarding';
import { cacheKeys } from '@/shared/lib/cache-invalidation';

/**
 * Fetch localized onboarding slides from the API.
 * Keyed on locale so switching app language refetches the translated copy.
 */
export function useOnboardingSlides(enabled: boolean) {
  const locale = useLocale();

  return useQuery<OnboardingSlide[]>({
    queryKey: cacheKeys.onboardingSlides(locale),
    queryFn: () => onboardingService.getSlides(),
    staleTime: 60 * 60 * 1000, // 1h — matches server-side cache window
    enabled,
  });
}
